<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full">
    <div
        class="w-full rounded-large bg-secondary-600 spacing-lg flex flex-col gap items-center relative">
        <img src="images/bg-grid.svg" alt="" class="w-full h-full absolute inset-0 object-cover" />

        <h2 class="text-center text-white z-10">
            Nie wieder auch nur einen Kunden der Konkurrenz abgeben. Überzeuge, noch bevor du auch
            nur ein Wort sagst.
        </h2>

        <p class="max-w-screen-sm text-center text-white z-10">
            Mit einem auf deine Bedürfnisse optimierten Online-Auftritt bleibst du auch in Zukunft
            marktfähig und stellst deine Konkurrenz in den Schatten.
        </p>

        <wci-button
            routerLink="/kontakt"
            class="z-10 block"
            label="Jetzt Marktvorteil sichern"
            variant="secondary"
            >Jetzt Marktvorteil sichern
        </wci-button>
    </div>
</div>
